webpackJsonp([0,4],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	// make sure we won't load jQuery in multiple files
	// import 'jquery'
	// import main loader
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(2);
	
	// load app
	
	var _systemApp = __webpack_require__(47);
	
	var _systemApp2 = _interopRequireDefault(_systemApp);
	
	// init
	var app = new _systemApp2['default']();
	window.App = app;

/***/ },

/***/ 2:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var moduleElements = document.querySelectorAll('[data-module]');
	
	var _loop = function () {
	  var el = moduleElements[i];
	  var name = el.getAttribute('data-module');
	  __webpack_require__.e/* nsure */(1, function () {
	    var Module = __webpack_require__(3)("./" + name);
	    new Module(el);
	  });
	};
	
	for (var i = 0; i < moduleElements.length; i++) {
	  _loop();
	}
	
	var componentElements = document.querySelectorAll('[data-component]');
	
	var _loop2 = function () {
	  var el = componentElements[i];
	  var name = el.getAttribute('data-component');
	  __webpack_require__.e/* nsure */(2, function () {
	    var Component = __webpack_require__(20)("./" + name);
	    new Component(el);
	  });
	};
	
	for (var i = 0; i < componentElements.length; i++) {
	  _loop2();
	}
	
	var entryElements = document.querySelectorAll('[data-entry]');
	
	var _loop3 = function () {
	  var el = entryElements[i];
	  var name = el.getAttribute('data-entry');
	  __webpack_require__.e/* nsure */(3, function () {
	    var Entry = __webpack_require__(45)("./" + name);
	    new Entry(el);
	  });
	};
	
	for (var i = 0; i < entryElements.length; i++) {
	  _loop3();
	}
	
	// Custom loader for Kentico forms
	// const kenticoForms = document.querySelectorAll('.FormPanel')
	// for (var i = 0; i < kenticoForms.length; i++) {
	//   const el = kenticoForms[i]
	//   require.ensure([], function() {
	//     const Entry = require(`../components/form`)
	//     new Entry(el)
	//   })
	// }

/***/ },

/***/ 5:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ComponentAbstract = (function () {
	  function ComponentAbstract(el, options, type) {
	    _classCallCheck(this, ComponentAbstract);
	
	    this.el = el;
	    this.$el = $(el);
	    this.type = type || 'module';
	    this.options = options || 'module';
	
	    this.options = $.extend(true, this.options, options, this.$el.data(type + '-options'));
	
	    this.mainClassName = this._getClassName();
	  }
	
	  _createClass(ComponentAbstract, [{
	    key: 'find',
	    value: function find(element, modifier, where) {
	
	      if (!this.mainClassName) {
	        console.error('cannot find main class name for ' + this.el);
	      }
	
	      modifier = modifier || false;
	      where = where || this.mainClassName;
	      var selector = '.' + where + '__' + element;
	      if (modifier) selector += '.-' + modifier;
	
	      return this.$el.find(selector);
	    }
	  }, {
	    key: 'setCookie',
	    value: function setCookie(cname, cvalue, exdays) {
	      var d = new Date();
	      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	      var expires = "expires=" + d.toGMTString();
	      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	    }
	  }, {
	    key: 'getCookie',
	    value: function getCookie(cname) {
	      var name = cname + "=";
	      var ca = document.cookie.split(';');
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	          c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	          return c.substring(name.length, c.length);
	        }
	      }
	      return "";
	    }
	  }, {
	    key: '_getClassName',
	    value: function _getClassName() {
	      var prefix = this.type === 'module' ? 'm-' : 'c-';
	      var className = this.el.className.split(' ').filter(function (cn) {
	        // //console.log(prefix, cn.indexOf(prefix))
	        return cn.indexOf(prefix) === 0;
	      });
	
	      if (className.length) {
	        return className[0];
	      } else {
	        // console.error('cannot find main class name for ' + this.type)
	        return false;
	      }
	    }
	  }]);
	
	  return ComponentAbstract;
	})();
	
	exports['default'] = ComponentAbstract;
	module.exports = exports['default'];

/***/ },

/***/ 40:
/***/ function(module, exports) {

	/**
	 * calculate the duration of the scroll animation based on the width of the banner and text
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.updateScrollAnimation = updateScrollAnimation;
	
	function updateScrollAnimation() {
	    var banner = document.querySelector('.scroll-banner');
	    var text = document.querySelector('.scroll-text');
	
	    if (banner && text) {
	        var bannerWidth = banner.offsetWidth;
	        var textWidth = text.offsetWidth;
	
	        var endPosition = -(textWidth + bannerWidth);
	
	        text.style.animation = "scrollText 30s linear infinite";
	        text.style.transform = "translateX(" + bannerWidth + "px)";
	
	        var style = document.createElement('style');
	        style.innerHTML = "@keyframes scrollText { from { transform: translateX(" + bannerWidth / 10 + "px); } to { transform: translateX(" + endPosition + "px); } }";
	        document.head.appendChild(style);
	    }
	}
	
	window.addEventListener('load', updateScrollAnimation);
	window.addEventListener('resize', updateScrollAnimation);

/***/ },

/***/ 47:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	// const attachFastClick = require('fastclick');
	
	var _componentsSiteWideBannerJs = __webpack_require__(40);
	
	var ResponsiveImageLoader = __webpack_require__(48);
	var PrintBehaviour = __webpack_require__(49);
	var KenticoBehaviourOverrides = __webpack_require__(50);
	var ContactFormKenticoLoading = __webpack_require__(51);
	var ViewportUnitsBuggyfill = __webpack_require__(52);
	var OnScreenItemToggler = __webpack_require__(53);
	var FastClick = __webpack_require__(54);
	var App = (function () {
	  function App(options) {
	    _classCallCheck(this, App);
	
	    this.options = $.extend({}, options);
	    this.initialise();
	  }
	
	  _createClass(App, [{
	    key: 'initialise',
	    value: function initialise() {
	      this.$body = $("body");
	      this.initSearchResultsFix();
	      this.initialiseRequestAnimationFrameScript();
	      new KenticoBehaviourOverrides({ disableKenticoFormSubmission: true });
	      new ContactFormKenticoLoading();
	      new PrintBehaviour();
	      ViewportUnitsBuggyfill.init();
	      FastClick.attach(document.body);
	      this.initialiseJqueryFunctions();
	      this.initialiseResponsiveImageLoader();
	      this.initialiseOnScreenItemToggler();
	      this.onWindowResized();
	      this.initialiseListeners();
	      this.initialiseSelectricForm();
	      (0, _componentsSiteWideBannerJs.updateScrollAnimation)();
	    }
	
	    // /giphy hack (see gitesh)
	  }, {
	    key: 'initSearchResultsFix',
	    value: function initSearchResultsFix() {
	      if (!$(".js-search-results-appendFrom").length) {
	        return;
	      }
	
	      var results = $('.js-search-results-appendFrom').text();
	      $('.js-search-results-appendTo').append(results);
	    }
	  }, {
	    key: 'initialiseRequestAnimationFrameScript',
	    value: function initialiseRequestAnimationFrameScript() {
	      // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	      // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	
	      // requestAnimationFrame polyfill by Erik Möller
	      // fixes from Paul Irish and Tino Zijdel
	
	      var lastTime = 0;
	      var vendors = ['ms', 'moz', 'webkit', 'o'];
	      for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	      }
	
	      if (!window.requestAnimationFrame) {
	        window.requestAnimationFrame = function (callback, element) {
	          var currTime = new Date().getTime();
	          var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	          var id = window.setTimeout(function () {
	            callback(currTime + timeToCall);
	          }, timeToCall);
	          lastTime = currTime + timeToCall;
	          return id;
	        };
	      }
	
	      if (!window.cancelAnimationFrame) {
	        window.cancelAnimationFrame = function (id) {
	          clearTimeout(id);
	        };
	      }
	    }
	  }, {
	    key: 'initialiseListeners',
	    value: function initialiseListeners() {
	      var _this = this;
	
	      $(window).resize(function () {
	        return _this.onWindowResized();
	      });
	    }
	  }, {
	    key: 'initialiseResponsiveImageLoader',
	    value: function initialiseResponsiveImageLoader() {
	      var responsiveImageLoaderOptions = { imageBreakPointSizes: [660, 1024, 1280, 1440], lazyLoadAllImages: true };
	      new ResponsiveImageLoader(responsiveImageLoaderOptions);
	    }
	  }, {
	    key: 'initialiseOnScreenItemToggler',
	    value: function initialiseOnScreenItemToggler() {
	      new OnScreenItemToggler();
	    }
	  }, {
	    key: 'initialiseJqueryFunctions',
	    value: function initialiseJqueryFunctions() {
	      //Case insensitive Jquery Contains method
	      $.expr[":"].containsNoCase = function (el, i, m) {
	        var search = m[3];
	        if (!search) {
	          return false;
	        }
	        return eval("/" + search + "/i").test($(el).text());
	      };
	    }
	  }, {
	    key: 'onWindowResized',
	    value: function onWindowResized() {
	
	      var desktopBreakpointSize = $("#bp-desktop").width();
	      this.$body.removeClass("desktop").removeClass("mobile");
	      if ($(window).outerWidth() >= desktopBreakpointSize) {
	        this.$body.addClass("desktop");
	      } else {
	        this.$body.addClass("mobile");
	      }
	    }
	  }, {
	    key: 'initialiseSelectricForm',
	    value: function initialiseSelectricForm() {
	      $('select').selectric();
	      $('select.c-label-select__fields').selectric({ disableOnMobile: false,
	        nativeOnMobile: false });
	      var pageRequestManager = Sys.WebForms.PageRequestManager.getInstance();
	      pageRequestManager.add_pageLoaded(onPageLoaded);
	
	      if (!pageRequestManager.get_isInAsyncPostBack()) {
	        pageRequestManager.add_beginRequest(BeginRequest);
	        pageRequestManager.add_endRequest(EndRequest);
	      }
	
	      function BeginRequest(sender, args) {
	        console.log('start');
	      }
	
	      function EndRequest(sender, args) {
	        console.log('end');
	      }
	
	      function onPageLoaded(sender, args) {
	        //Loads everytime a page loads
	        $('select').selectric();
	        $('select.c-label-select__fields').selectric({ disableOnMobile: false,
	          nativeOnMobile: false });
	
	        var panels = args.get_panelsUpdated();
	        if (panels.length) {
	          //Only happens when it is a postback
	          console.log("async panel update");
	        }
	      }
	    }
	  }]);
	
	  return App;
	})();
	
	exports['default'] = App;
	module.exports = exports['default'];

/***/ },

/***/ 48:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResponsiveImageLoader = (function () {
	  function ResponsiveImageLoader(options) {
	    var _this = this;
	
	    _classCallCheck(this, ResponsiveImageLoader);
	
	    this.options = options;
	    var imageBreakPointSizes = this.setItemFromOptionsOrDefault("imageBreakPointSizes");
	    if (!imageBreakPointSizes) {
	      //Should look something like  [640, 1024, 1280, 1440]
	      throw "No Image Break Points given to Responsive Image Loader";
	      return;
	    }
	
	    this.DESKTOP_BREAKPOINT_WIDTH = this.setItemFromOptionsOrDefault("desktopBreakPointWidth", 768);
	    this.DEBOUNCE_DURATION_MILLISECONDS = this.setItemFromOptionsOrDefault("debounceDurationMilliseconds", 500);
	    this.LAZY_LOAD_ALL_IMAGES_ENABLED = this.setItemFromOptionsOrDefault("lazyLoadAllImages", false);
	    this.LAZY_LOAD_BY_CLASS_ENABLED = this.setItemFromOptionsOrDefault("lazyLoadByClass", false);
	    this.LAZY_LOAD_CLASS = "-lazy-load";
	    this.LAZY_LOAD_PERCENTAGE_OF_WINDOW_HEIGHT = 10;
	    this.RESIZE_IMAGE_BREAKPOINTS = imageBreakPointSizes;
	
	    //VARIABLES
	    this.previousWindowWidth = NaN;
	    this.m_lastFetchedImageSize = 0;
	    this.m_bIsDesktop = false;
	    this.m_debounceTimer = null;
	
	    this.initialiseListeners();
	
	    window.setTimeout(function () {
	      return _this.onWindowResizeSettled();
	    }, 500);
	  }
	
	  _createClass(ResponsiveImageLoader, [{
	    key: "initialiseListeners",
	    value: function initialiseListeners() {
	      var _this2 = this;
	
	      if (this.LAZY_LOAD_ALL_IMAGES_ENABLED || this.LAZY_LOAD_BY_CLASS_ENABLED) {
	        $(window).scroll(function () {
	          return _this2.onWindowScroll();
	        });
	      }
	
	      $("body").on("responsive-image-check", function () {
	        return _this2.onWindowResizeSettled(false);
	      });
	      $(window).on("resize", function () {
	        return _this2.onWindowResized();
	      });
	      $("body").on("responsive-image", function (e, _additionalEventObject) {
	        return _this2.onResponsiveImageEvent(e, _additionalEventObject);
	      });
	    }
	  }, {
	    key: "onWindowResized",
	    value: function onWindowResized() {
	      //Add some debounce incase they're resizing the window very quickly between small and large, you dont want to load the medium sized images if they dont really need them
	      this.resetDebounceTimer();
	    }
	  }, {
	    key: "onWindowScroll",
	    value: function onWindowScroll() {
	      var $dataResponsiveLazyLoadElements = false;
	
	      if (this.LAZY_LOAD_ALL_IMAGES_ENABLED) {
	        $dataResponsiveLazyLoadElements = $("[data-responsive-image]:visible");
	      } else if (this.LAZY_LOAD_BY_CLASS_ENABLED) {
	        $dataResponsiveLazyLoadElements = $(".-lazy-load[data-responsive-image]:visible");
	      } else {
	        return;
	      }
	      this.fetchIdealResponsiveImagery($dataResponsiveLazyLoadElements);
	    }
	  }, {
	    key: "setItemFromOptionsOrDefault",
	    value: function setItemFromOptionsOrDefault(_key, _default) {
	      if (typeof _default === "undefined") {
	        _default = false;
	      }
	
	      if (typeof this.options[_key] === "undefined") {
	        return _default;
	      }
	
	      return this.options[_key];
	    }
	  }, {
	    key: "onResponsiveImageEvent",
	    value: function onResponsiveImageEvent(e) {
	      var _additionalEventObject = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (!_additionalEventObject || typeof _additionalEventObject.$responsiveImageTargets === "undefined") {
	        console.log("---onResponsiveImageEvent--- Failed to get responsive Image Targets in _additionalEventObject");
	        console.log(_additionalEventObject);
	        return false;
	      }
	      console.log("onResponsiveImageEvent");
	
	      var onCompleteCallback = typeof _additionalEventObject.onComplete !== "undefined" ? _additionalEventObject.onComplete : null;
	
	      this.fetchIdealResponsiveImagery(_additionalEventObject.$responsiveImageTargets, onCompleteCallback);
	    }
	  }, {
	    key: "resetDebounceTimer",
	    value: function resetDebounceTimer() {
	      var _this3 = this;
	
	      if (this.m_debounceTimer !== null) {
	        window.clearTimeout(this.m_debounceTimer);
	        this.m_debounceTimer = null;
	      }
	
	      this.m_debounceTimer = window.setTimeout(function () {
	        return _this3.onWindowResizeSettled();
	      }, this.DEBOUNCE_DURATION_MILLISECONDS);
	    }
	  }, {
	    key: "isDesktopBreakpoint",
	    value: function isDesktopBreakpoint() {
	      var windowSize = $(window).width();
	      var bIsDesktop = windowSize >= this.DESKTOP_BREAKPOINT_WIDTH;
	      return bIsDesktop;
	    }
	  }, {
	    key: "onWindowResizeSettled",
	    value: function onWindowResizeSettled(_ignoreIfSameWindowWidth) {
	      if (typeof _ignoreIfSameWindowWidth === "undefined") {
	        _ignoreIfSameWindowWidth = true;
	      }
	
	      var windowSize = $(window).width();
	
	      if (_ignoreIfSameWindowWidth && this.previousWindowWidth === windowSize) {
	        //No point in resizing the images, as they're based on the width of the browser
	        //it may have been vertically resized, like scrolling on an ipad and the tab bar disappears
	        return;
	      }
	
	      this.previousWindowWidth = windowSize;
	      this.fetchIdealResponsiveImagery();
	    }
	  }, {
	    key: "isElementOnScreenOrNear",
	    value: function isElementOnScreenOrNear(_$element) {
	      var scrollTop = $(window).scrollTop();
	      var elementTopOffset = _$element.offset().top;
	      var windowInnerHeight = $(window).innerHeight();
	      var scrollTopBottomWindow = scrollTop + windowInnerHeight;
	      var scrollTopBottomWindowWithBottomBuffer = scrollTopBottomWindow + windowInnerHeight * (this.LAZY_LOAD_PERCENTAGE_OF_WINDOW_HEIGHT * 0.01);
	      if (scrollTopBottomWindowWithBottomBuffer < elementTopOffset) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: "fetchIdealResponsiveImagery",
	    value: function fetchIdealResponsiveImagery(_$selectedItems, _onLoadedCallback) {
	      if (_$selectedItems === undefined) _$selectedItems = false;
	
	      if (typeof _onLoadedCallback === "undefined") {
	        _onLoadedCallback = null;
	      }
	      // console.log("--fetchIdealResponsiveImagery--");
	      if (!_$selectedItems) {
	        _$selectedItems = $("[data-responsive-image]:visible").not(".-defer-loading");
	      }
	
	      _$selectedItems = _$selectedItems.not(".-loading").not(".-error-loading");
	
	      this.m_bIsDesktop = this.isDesktopBreakpoint();
	      var queryParams = "?width=";
	      var context = this;
	      _$selectedItems.each(function () {
	        var $this = $(this);
	        // if($this.hasClass("-lazy-load"))
	        if ((context.LAZY_LOAD_ALL_IMAGES_ENABLED || $this.hasClass(context.LAZY_LOAD_CLASS && context.LAZY_LOAD_BY_CLASS_ENABLED)) && !context.isElementOnScreenOrNear($this)) {
	          // console.log("Not on screen so not loading the image");
	          return;
	        }
	
	        var responsiveImageURL = $this.data("responsive-image");
	        var recommendedImageSize = context.getRecommendedImageSizeFromElement($this);
	        var fullQueryURL = context.appendGetParamaters("width", recommendedImageSize, responsiveImageURL);
	
	        var backgroundImageURL = $this.css("background-image");
	        if (backgroundImageURL.indexOf(fullQueryURL.replace("../", "")) >= 0) {
	          if (typeof _onLoadedCallback === "function") {
	            _onLoadedCallback.call();
	          }
	          return;
	        }
	
	        if (backgroundImageURL === "none") {
	          // console.log("Has not loaded atleast one image");
	          // $this.addClass("-loading");
	          context.addLoadingItemsToElement($this);
	        } else {
	          // console.log("loading new");
	          // console.log("backgroundImageURL: " + backgroundImageURL);
	          // console.log("fullQueryURL: " + fullQueryURL);
	        }
	
	        fullQueryURL = context.appendGetCropValue($this, fullQueryURL);
	        context.preloadImage(fullQueryURL, $this, recommendedImageSize, _onLoadedCallback);
	      });
	    }
	  }, {
	    key: "addLoadingItemsToElement",
	    value: function addLoadingItemsToElement(_$element) {
	      _$element.addClass("-loading");
	
	      if (_$element.find(".uil-spin-css").length) {
	        return;
	      }
	
	      var html = "<div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>";
	
	      _$element.append(html);
	    }
	  }, {
	    key: "appendGetCropValue",
	    value: function appendGetCropValue(_$element, _responsiveImageURL) {
	      var cropParams = false;
	      if (this.m_bIsDesktop) {
	        var elementWidth = _$element.width() | 0;
	        var elementHeight = _$element.height() | 0;
	
	        if (elementWidth && elementHeight) {
	          if (elementWidth === elementHeight) {
	            cropParams = _$element.data("crop-square");
	          } else if (elementWidth > elementHeight) {
	            cropParams = _$element.data("crop-landscape");
	          } else if (elementHeight > elementWidth) {
	            cropParams = _$element.data("crop-portrait");
	          }
	        } else {
	          //go off classes of the element (if width and height cant be detected)
	
	          if (_$element.hasClass("-even-width-height") || _$element.hasClass('-slightly-short')) {
	            cropParams = _$element.data("crop-square");
	          } else if (_$element.hasClass("-double-width") || _$element.hasClass("-four-by-three") || _$element.hasClass("-sixteen-by-ten")) {
	            cropParams = _$element.data("crop-landscape");
	          } else if (_$element.hasClass('-three-by-four') || _$element.hasClass('-slightly-long')) {
	            cropParams = _$element.data("crop-portrait");
	          } else {
	            cropParams = _$element.data("crop-landscape");
	          }
	
	          //Default to landsacpe if all else fails
	        }
	      } else {
	          //Mobile
	          cropParams = _$element.data("crop-mobile");
	        }
	
	      if (!cropParams) {
	        return _responsiveImageURL;
	      }
	
	      _responsiveImageURL = this.appendGetParamaters("crop", cropParams, _responsiveImageURL);
	
	      return _responsiveImageURL;
	    }
	  }, {
	    key: "appendGetParamaters",
	    value: function appendGetParamaters(_key, _value, _stringToReturn) {
	      if (_stringToReturn.indexOf("?") > -1) {
	        _stringToReturn += "&";
	      } else {
	        _stringToReturn += "?";
	      }
	
	      _stringToReturn += _key + "=" + _value;
	      return _stringToReturn;
	    }
	  }, {
	    key: "getRecommendedImageSizeFromElement",
	    value: function getRecommendedImageSizeFromElement(_$element) {
	      var imageContainerSize = _$element.width();
	      var fetchImageSize = this.RESIZE_IMAGE_BREAKPOINTS[0];
	      //Fetch the minimum biggest size
	      for (var i = 0; i < this.RESIZE_IMAGE_BREAKPOINTS.length; i++) {
	        var imageBreakpointSize = this.RESIZE_IMAGE_BREAKPOINTS[i];
	        if (imageBreakpointSize > imageContainerSize) {
	          fetchImageSize = imageBreakpointSize;
	          break;
	        } else if (i === this.RESIZE_IMAGE_BREAKPOINTS.length - 1) {
	          fetchImageSize = imageBreakpointSize;
	        }
	      }
	
	      return fetchImageSize;
	    }
	  }, {
	    key: "removeLoadingState",
	    value: function removeLoadingState(_$element) {
	      _$element.removeClass("-loading");
	      _$element.find(".uil-spin-css").remove();
	    }
	
	    //Stops the
	  }, {
	    key: "preloadImage",
	    value: function preloadImage(source, _$element, _initialRecommendedImageSize, _onCompleteCallback) {
	      if (typeof _onCompleteCallback !== "function") {
	        _onCompleteCallback = null;
	      }
	
	      var image = new Image();
	      image.src = source;
	      var context = this;
	      image.onload = function () {
	        context.removeLoadingState(_$element);
	        _$element.addClass("-loaded");
	        //Now that it's loaded we just need to make sure it is still relevant (the browser hasnt changed size again since)
	        var currentRecommendedImageSize = context.getRecommendedImageSizeFromElement(_$element);
	        if (currentRecommendedImageSize !== _initialRecommendedImageSize) {
	          return; //dont do anything, as this image might have loaded AFTEr another image was requested, and is now irrelavant
	        }
	
	        var cssBackground = 'url(' + image.src + ')';
	        _$element.css('background-image', cssBackground);
	
	        if (_$element.hasClass("-native-aspect-ratio") && _$element.hasClass("-aspect-ratio")) {
	          //If it has this class, then it overrides the class based aspect ratio to the native image aspect ratio
	          // padding-bottom: (100/160) * 100%; (based on this css)
	          var paddingBottom = image.height / image.width * 100;
	          _$element.css("padding-bottom", paddingBottom + "%");
	        }
	        if (_onCompleteCallback) {
	          _onCompleteCallback.call();
	        }
	      };
	
	      image.onerror = function () {
	        context.removeLoadingState(_$element);
	        _$element.addClass("-loaded");
	        _$element.addClass("-error-loading");
	        if (_onCompleteCallback) {
	          _onCompleteCallback.call();
	        }
	      };
	    }
	  }]);
	
	  return ResponsiveImageLoader;
	})();
	
	exports["default"] = ResponsiveImageLoader;
	module.exports = exports["default"];

/***/ },

/***/ 49:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PrintBehaviour = (function () {
	  function PrintBehaviour(options) {
	    var _this = this;
	
	    _classCallCheck(this, PrintBehaviour);
	
	    if (!$(".b-header").length || $(".b-header").is(":visible")) {
	      return;
	    }
	    console.log();
	
	    this.PDF_EXPORT_PAGE_WIDTH = 1600;
	    this.PDF_EXPORT_PAGE_HEIGHT = 2505;
	    // this.PDF_EXPORT_PAGE_HEIGHT = 1370;
	
	    this.options = $.extend({ replaceBGImages: true, testing: true }, options);
	
	    if (this.options.replaceBGImages) {
	      this.replaceBGImages();
	    }
	
	    if (this.options.testing) {
	      this.setVisiblePageLines();
	    }
	
	    window.setTimeout(function () {
	      return _this.setPageBreaks();
	    }, 2000);
	    // this.setPageBreaks();
	  }
	
	  // print-behaviour.js
	
	  // -replace-with-img-for-print
	
	  _createClass(PrintBehaviour, [{
	    key: "replaceBGImages",
	    value: function replaceBGImages() {
	      var $imageBGsToReplace = $(".-replace-with-img-for-print");
	      console.log("num bg images for print: " + $imageBGsToReplace.length);
	
	      $imageBGsToReplace.each(function () {
	        var $currentBGImageElement = $(this);
	        $currentBGImageElement.css("position", "relative");
	        $currentBGImageElement.css("overflow", "hidden");
	        var imageHTMLTag = "<img src='" + $currentBGImageElement.attr("data-responsive-image") + "' class='bg-img-replacement' />";
	        $currentBGImageElement.removeAttr("data-responsive-image");
	        $currentBGImageElement.html(imageHTMLTag);
	      });
	    }
	  }, {
	    key: "setVisiblePageLines",
	    value: function setVisiblePageLines() {
	      // var heightOfWindow = 8000;
	      // var INDICATION_EVERY_N_PIXELS = 10;
	      // var loopNumTimes = heightOfWindow / INDICATION_EVERY_N_PIXELS;
	
	      // for (var i = 0; i < loopNumTimes; i++)
	      // {
	      //   var loopPixel = i*INDICATION_EVERY_N_PIXELS;
	      //   var element = "<h1 style='position:fixed;left:0;top:"+loopPixel+"px;'>"+loopPixel+"</h1>";
	      //   $("body").append(element);
	      // }
	    }
	  }, {
	    key: "setPageBreaks",
	    value: function setPageBreaks() {
	      console.log("setPageBreaks");
	      $(".-print-page-break-after").removeClass("-print-page-break-after");
	      $(".-print-page-break-before").removeClass("-print-page-break-before");
	
	      var loopPages = 5;
	      // var html = "";
	      // for (var i = 0; i < loopPages; i++)
	      // { 
	      //   var topPosition = this.PDF_EXPORT_PAGE_HEIGHT * (i+1);
	      //   html += "<div class='-print-page-indicator' style='top:"+topPosition+"px;'></div>"
	      // }
	      // $("body").append(html);
	
	      var context = this;
	      $("[data-print-break-type]").each(function () {
	        var $this = $(this);
	        var options = $this.data("print-break-options");
	        switch ($this.attr("data-print-break-type")) {
	          case "child-on-different-page-then-container":
	            {
	              context.checkChildOnDifferentPageThenContainer.call(context, $this, options);
	              break;
	            }
	        }
	      });
	
	      $(".-page-break-if-over-two-pages").each(function () {
	        var $this = $(this);
	        context.pageBreakIfElementOverTwoPages.call(context, $this);
	      });
	    }
	  }, {
	    key: "checkChildOnDifferentPageThenContainer",
	    value: function checkChildOnDifferentPageThenContainer(_$element, options) {
	      //keys in options:
	      //containerSelector
	      //childSelector
	
	      console.log(options);
	      var $container = _$element.closest(options.containerSelector);
	      var $childSelector = _$element.find(options.childSelector);
	
	      var containerPage = this.getPageElementIsOn($container);
	      var childPage = this.getPageElementIsOn($childSelector, true);
	
	      if (containerPage === childPage) {
	        //dont need to do anything
	        return;
	      }
	
	      //break at the container
	      $("body").html("Print Page Break Before");
	      $container.addClass("-print-page-break-before");
	    }
	  }, {
	    key: "pageBreakIfElementOverTwoPages",
	    value: function pageBreakIfElementOverTwoPages(_$element) {
	      var topOffsetY = _$element.offset().top;
	      var bottomOffsetY = topOffsetY + _$element.height();
	
	      var topOffsetPage = this.getPageYPixelIsOn(topOffsetY);
	      var bottomOffsetPage = this.getPageYPixelIsOn(bottomOffsetY);
	
	      if (topOffsetPage !== bottomOffsetPage) {
	        _$element.addClass("-print-page-break-before");
	      }
	    }
	  }, {
	    key: "getPageElementIsOn",
	    value: function getPageElementIsOn(_$element, _fromBottomOfElement) {
	      if (typeof _fromBottomOfElement === "undefined") {
	        _fromBottomOfElement = false;
	      }
	
	      var elementOffsetY = _$element.offset().top;
	
	      if (_fromBottomOfElement) {
	        elementOffsetY += _$element.height();
	      }
	
	      return this.getPageYPixelIsOn(elementOffsetY);
	    }
	  }, {
	    key: "getPageYPixelIsOn",
	    value: function getPageYPixelIsOn(_pixelYValue) {
	      var numberOfPagesToCheck = 20;
	      for (var i = 0; i < numberOfPagesToCheck; i++) {
	        var pageNumberToCheck = i + 1;
	        var bottomOfPageYPosition = this.PDF_EXPORT_PAGE_HEIGHT * pageNumberToCheck;
	
	        if (_pixelYValue < bottomOfPageYPosition) {
	          return pageNumberToCheck;
	        }
	      }
	
	      return -1;
	    }
	
	    //data-print-break-type="child-on-different-page-then-container" data-print-break-options='{"containerSelector":".m-accordion__item","childSelector":"ul > li:first"}'
	  }]);
	
	  return PrintBehaviour;
	})();
	
	exports["default"] = PrintBehaviour;
	module.exports = exports["default"];

/***/ },

/***/ 50:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KenticoBehaviourOverrides = (function () {
	  function KenticoBehaviourOverrides(options) {
	    _classCallCheck(this, KenticoBehaviourOverrides);
	
	    this.options = $.extend({ disableKenticoFormSubmission: false }, options);
	
	    if (this.options.disableKenticoFormSubmission) {
	      this.disableKenticoFormSubmission();
	    }
	  }
	
	  //Disables submission of the global kentico form
	
	  _createClass(KenticoBehaviourOverrides, [{
	    key: "disableKenticoFormSubmission",
	    value: function disableKenticoFormSubmission() {
	      var _this = this;
	
	      $("#aspnetForm").submit(function (e) {
	        return _this.onASPNetFormSubmission(e);
	      });
	    }
	  }, {
	    key: "onASPNetFormSubmission",
	    value: function onASPNetFormSubmission(e) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }]);
	
	  return KenticoBehaviourOverrides;
	})();
	
	exports["default"] = KenticoBehaviourOverrides;
	module.exports = exports["default"];

/***/ },

/***/ 51:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var ContactFormKenticoLoading = (function () {
	    function ContactFormKenticoLoading() {
	        _classCallCheck(this, ContactFormKenticoLoading);
	
	        if (typeof window['Sys'] === 'undefined' || typeof window['Sys']['WebForms'] === 'undefined' || typeof window['Sys']['WebForms']['PageRequestManager'] === 'undefined') {
	            console.error('Kentico Web Forms JavaScript not found (Currently running outside of kentico?)');
	            return;
	        }
	
	        if ($('.FormPanel').length === 0) {
	            //more than one form panel on the page
	            console.error('Error: No form panels found on page');
	            return;
	        }
	
	        if ($('.FormPanel').length > 1) {
	            //more than one form panel on the page
	            console.error('Error: More than one form panel found on page');
	            return;
	        }
	        this.initialiseListeners();
	    }
	
	    _createClass(ContactFormKenticoLoading, [{
	        key: 'initialiseListeners',
	        value: function initialiseListeners() {
	
	            var pageRequestManager = Sys.WebForms.PageRequestManager.getInstance();
	            pageRequestManager.add_pageLoaded(this.onPageLoaded.bind(this));
	
	            if (!pageRequestManager.get_isInAsyncPostBack()) {
	                pageRequestManager.add_beginRequest(this.beginRequest.bind(this));
	                pageRequestManager.add_endRequest(this.endRequest.bind(this));
	            }
	        }
	    }, {
	        key: 'beginRequest',
	        value: function beginRequest(sender, args) {
	            var $submitButton = $('.FormPanel input[type="submit"]');
	            $submitButton.hide();
	            $submitButton.parent().css('position', 'relative');
	            var htmlLoader = "<div class='-loading -loader-wrapper -loading-inline -no-colour-loading-bg'><div class='uil-spin-css -white'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	            $submitButton.parent().append(htmlLoader);
	        }
	    }, {
	        key: 'endRequest',
	        value: function endRequest(sender, args) {
	            var $submitButton = $('.FormPanel input[type="submit"]');
	            $submitButton.show();
	            $submitButton.parent().find('.-loading-wrapper').remove();
	        }
	    }, {
	        key: 'onPageLoaded',
	        value: function onPageLoaded(sender, args) {}
	    }]);
	
	    return ContactFormKenticoLoading;
	})();
	
	exports['default'] = ContactFormKenticoLoading;
	module.exports = exports['default'];

/***/ },

/***/ 52:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * viewport-units-buggyfill v0.6.0
	 * @web: https://github.com/rodneyrehm/viewport-units-buggyfill/
	 * @author: Rodney Rehm - http://rodneyrehm.de/en/
	 */
	
	(function (root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like enviroments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.viewportUnitsBuggyfill = factory();
	  }
	}(this, function () {
	  'use strict';
	  /*global document, window, navigator, location, XMLHttpRequest, XDomainRequest, CustomEvent*/
	
	  var initialized = false;
	  var options;
	  var userAgent = window.navigator.userAgent;
	  var viewportUnitExpression = /([+-]?[0-9.]+)(vh|vw|vmin|vmax)/g;
	  var forEach = [].forEach;
	  var dimensions;
	  var declarations;
	  var styleNode;
	  var isBuggyIE = /MSIE [0-9]\./i.test(userAgent);
	  var isOldIE = /MSIE [0-8]\./i.test(userAgent);
	  var isOperaMini = userAgent.indexOf('Opera Mini') > -1;
	
	  var isMobileSafari = /(iPhone|iPod|iPad).+AppleWebKit/i.test(userAgent) && (function() {
	    // Regexp for iOS-version tested against the following userAgent strings:
	    // Example WebView UserAgents:
	    // * iOS Chrome on iOS8: "Mozilla/5.0 (iPad; CPU OS 8_1 like Mac OS X) AppleWebKit/600.1.4 (KHTML, like Gecko) CriOS/39.0.2171.50 Mobile/12B410 Safari/600.1.4"
	    // * iOS Facebook on iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_1 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D201 [FBAN/FBIOS;FBAV/12.1.0.24.20; FBBV/3214247; FBDV/iPhone6,1;FBMD/iPhone; FBSN/iPhone OS;FBSV/7.1.1; FBSS/2; FBCR/AT&T;FBID/phone;FBLC/en_US;FBOP/5]"
	    // Example Safari UserAgents:
	    // * Safari iOS8: "Mozilla/5.0 (iPhone; CPU iPhone OS 8_0 like Mac OS X) AppleWebKit/600.1.3 (KHTML, like Gecko) Version/8.0 Mobile/12A4345d Safari/600.1.4"
	    // * Safari iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_0 like Mac OS X) AppleWebKit/537.51.1 (KHTML, like Gecko) Version/7.0 Mobile/11A4449d Safari/9537.53"
	    var iOSversion = userAgent.match(/OS (\d)/);
	    // viewport units work fine in mobile Safari and webView on iOS 8+
	    return iOSversion && iOSversion.length>1 && parseInt(iOSversion[1]) < 10;
	  })();
	
	  var isBadStockAndroid = (function() {
	    // Android stock browser test derived from
	    // http://stackoverflow.com/questions/24926221/distinguish-android-chrome-from-stock-browser-stock-browsers-user-agent-contai
	    var isAndroid = userAgent.indexOf(' Android ') > -1;
	    if (!isAndroid) {
	      return false;
	    }
	
	    var isStockAndroid = userAgent.indexOf('Version/') > -1;
	    if (!isStockAndroid) {
	      return false;
	    }
	
	    var versionNumber = parseFloat((userAgent.match('Android ([0-9.]+)') || [])[1]);
	    // anything below 4.4 uses WebKit without *any* viewport support,
	    // 4.4 has issues with viewport units within calc()
	    return versionNumber <= 4.4;
	  })();
	
	  // added check for IE10, IE11 and Edge < 20, since it *still* doesn't understand vmax
	  // http://caniuse.com/#feat=viewport-units
	  if (!isBuggyIE) {
	    isBuggyIE = !!navigator.userAgent.match(/Trident.*rv[ :]*1[01]\.| Edge\/1\d\./);
	  }
	
	  // Polyfill for creating CustomEvents on IE9/10/11
	  // from https://github.com/krambuhl/custom-event-polyfill
	  try {
	    new CustomEvent('test');
	  } catch(e) {
	    var CustomEvent = function(event, params) {
	      var evt;
	      params = params || {
	        bubbles: false,
	        cancelable: false,
	        detail: undefined
	      };
	
	      evt = document.createEvent('CustomEvent');
	      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	      return evt;
	    };
	    CustomEvent.prototype = window.Event.prototype;
	    window.CustomEvent = CustomEvent; // expose definition to window
	  }
	
	  function debounce(func, wait) {
	    var timeout;
	    return function() {
	      var context = this;
	      var args = arguments;
	      var callback = function() {
	        func.apply(context, args);
	      };
	
	      clearTimeout(timeout);
	      timeout = setTimeout(callback, wait);
	    };
	  }
	
	  // from http://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
	  function inIframe() {
	    try {
	      return window.self !== window.top;
	    } catch (e) {
	      return true;
	    }
	  }
	
	  function initialize(initOptions) {
	    if (initialized) {
	      return;
	    }
	
	    if (initOptions === true) {
	      initOptions = {
	        force: true
	      };
	    }
	
	    options = initOptions || {};
	    options.isMobileSafari = isMobileSafari;
	    options.isBadStockAndroid = isBadStockAndroid;
	
	    if (options.ignoreVmax && !options.force && !isOldIE) {
	      // modern IE (10 and up) do not support vmin/vmax,
	      // but chances are this unit is not even used, so
	      // allow overwriting the "hacktivation"
	      // https://github.com/rodneyrehm/viewport-units-buggyfill/issues/56
	      isBuggyIE = false;
	    }
	
	    if (isOldIE || (!options.force && !isMobileSafari && !isBuggyIE && !isBadStockAndroid && !isOperaMini && (!options.hacks || !options.hacks.required(options)))) {
	      // this buggyfill only applies to mobile safari, IE9-10 and the Stock Android Browser.
	      if (window.console && isOldIE) {
	        console.info('viewport-units-buggyfill requires a proper CSSOM and basic viewport unit support, which are not available in IE8 and below');
	      }
	
	      return {
	        init: function () {}
	      };
	    }
	
	    // fire a custom event that buggyfill was initialize
	    window.dispatchEvent(new CustomEvent('viewport-units-buggyfill-init'));
	
	    options.hacks && options.hacks.initialize(options);
	
	    initialized = true;
	    styleNode = document.createElement('style');
	    styleNode.id = 'patched-viewport';
	    document.head.appendChild(styleNode);
	
	    // Issue #6: Cross Origin Stylesheets are not accessible through CSSOM,
	    // therefore download and inject them as <style> to circumvent SOP.
	    importCrossOriginLinks(function() {
	      var _refresh = debounce(refresh, options.refreshDebounceWait || 100);
	      // doing a full refresh rather than updateStyles because an orientationchange
	      // could activate different stylesheets
	      window.addEventListener('orientationchange', _refresh, true);
	      // orientationchange might have happened while in a different window
	      window.addEventListener('pageshow', _refresh, true);
	
	      if (options.force || isBuggyIE || inIframe()) {
	        window.addEventListener('resize', _refresh, true);
	        options._listeningToResize = true;
	      }
	
	      options.hacks && options.hacks.initializeEvents(options, refresh, _refresh);
	
	      refresh();
	    });
	  }
	
	  function updateStyles() {
	    styleNode.textContent = getReplacedViewportUnits();
	    // move to the end in case inline <style>s were added dynamically
	    styleNode.parentNode.appendChild(styleNode);
	    // fire a custom event that styles were updated
	    window.dispatchEvent(new CustomEvent('viewport-units-buggyfill-style'));
	  }
	
	  function refresh() {
	    if (!initialized) {
	      return;
	    }
	
	    findProperties();
	
	    // iOS Safari will report window.innerWidth and .innerHeight as 0 unless a timeout is used here.
	    // TODO: figure out WHY innerWidth === 0
	    setTimeout(function() {
	      updateStyles();
	    }, 1);
	  }
	  
	  // http://stackoverflow.com/a/23613052
	  function processStylesheet(ss) {
	    // cssRules respects same-origin policy, as per
	    // https://code.google.com/p/chromium/issues/detail?id=49001#c10.
	    try {
	      if (!ss.cssRules) { return; }
	    } catch(e) {
	      if (e.name !== 'SecurityError') { throw e; }
	      return;
	    }
	    // ss.cssRules is available, so proceed with desired operations.
	    var rules = [];
	    for (var i = 0; i < ss.cssRules.length; i++) {
	      var rule = ss.cssRules[i];
	      rules.push(rule);
	    }
	    return rules;
	  }
	
	  function findProperties() {
	    declarations = [];
	    forEach.call(document.styleSheets, function(sheet) {
	      var cssRules = processStylesheet(sheet);
	
	      if (!cssRules || sheet.ownerNode.id === 'patched-viewport' || sheet.ownerNode.getAttribute('data-viewport-units-buggyfill') === 'ignore') {
	        // skip entire sheet because no rules are present, it's supposed to be ignored or it's the target-element of the buggyfill
	        return;
	      }
	
	      if (sheet.media && sheet.media.mediaText && window.matchMedia && !window.matchMedia(sheet.media.mediaText).matches) {
	        // skip entire sheet because media attribute doesn't match
	        return;
	      }
	
	      forEach.call(cssRules, findDeclarations);
	    });
	
	    return declarations;
	  }
	
	  function findDeclarations(rule) {
	    if (rule.type === 7) {
	      var value;
	
	      // there may be a case where accessing cssText throws an error.
	      // I could not reproduce this issue, but the worst that can happen
	      // this way is an animation not running properly.
	      // not awesome, but probably better than a script error
	      // see https://github.com/rodneyrehm/viewport-units-buggyfill/issues/21
	      try {
	        value = rule.cssText;
	      } catch(e) {
	        return;
	      }
	
	      viewportUnitExpression.lastIndex = 0;
	      if (viewportUnitExpression.test(value)) {
	        // KeyframesRule does not have a CSS-PropertyName
	        declarations.push([rule, null, value]);
	        options.hacks && options.hacks.findDeclarations(declarations, rule, null, value);
	      }
	
	      return;
	    }
	
	    if (!rule.style) {
	      if (!rule.cssRules) {
	        return;
	      }
	
	      forEach.call(rule.cssRules, function(_rule) {
	        findDeclarations(_rule);
	      });
	
	      return;
	    }
	
	    forEach.call(rule.style, function(name) {
	      var value = rule.style.getPropertyValue(name);
	      // preserve those !important rules
	      if (rule.style.getPropertyPriority(name)) {
	        value += ' !important';
	      }
	
	      viewportUnitExpression.lastIndex = 0;
	      if (viewportUnitExpression.test(value)) {
	        declarations.push([rule, name, value]);
	        options.hacks && options.hacks.findDeclarations(declarations, rule, name, value);
	      }
	    });
	  }
	
	  function getReplacedViewportUnits() {
	    dimensions = getViewport();
	
	    var css = [];
	    var buffer = [];
	    var open;
	    var close;
	
	    declarations.forEach(function(item) {
	      var _item = overwriteDeclaration.apply(null, item);
	      var _open = _item.selector.length ? (_item.selector.join(' {\n') + ' {\n') : '';
	      var _close = new Array(_item.selector.length + 1).join('\n}');
	
	      if (!_open || _open !== open) {
	        if (buffer.length) {
	          css.push(open + buffer.join('\n') + close);
	          buffer.length = 0;
	        }
	
	        if (_open) {
	          open = _open;
	          close = _close;
	          buffer.push(_item.content);
	        } else {
	          css.push(_item.content);
	          open = null;
	          close = null;
	        }
	
	        return;
	      }
	
	      if (_open && !open) {
	        open = _open;
	        close = _close;
	      }
	
	      buffer.push(_item.content);
	    });
	
	    if (buffer.length) {
	      css.push(open + buffer.join('\n') + close);
	    }
	
	    // Opera Mini messes up on the content hack (it replaces the DOM node's innerHTML with the value).
	    // This fixes it. We test for Opera Mini only since it is the most expensive CSS selector
	    // see https://developer.mozilla.org/en-US/docs/Web/CSS/Universal_selectors
	    if (isOperaMini) {
	      css.push('* { content: normal !important; }');
	    }
	
	    return css.join('\n\n');
	  }
	
	  function overwriteDeclaration(rule, name, value) {
	    var _value;
	    var _selectors = [];
	
	    _value = value.replace(viewportUnitExpression, replaceValues);
	
	    if (options.hacks) {
	      _value = options.hacks.overwriteDeclaration(rule, name, _value);
	    }
	
	    if (name) {
	      // skipping KeyframesRule
	      _selectors.push(rule.selectorText);
	      _value = name + ': ' + _value + ';';
	    }
	
	    var _rule = rule.parentRule;
	    while (_rule) {
	      _selectors.unshift('@media ' + _rule.media.mediaText);
	      _rule = _rule.parentRule;
	    }
	
	    return {
	      selector: _selectors,
	      content: _value
	    };
	  }
	
	  function replaceValues(match, number, unit) {
	    var _base = dimensions[unit];
	    var _number = parseFloat(number) / 100;
	    return (_number * _base) + 'px';
	  }
	
	  function getViewport() {
	    var vh = window.innerHeight;
	    var vw = window.innerWidth;
	
	    return {
	      vh: vh,
	      vw: vw,
	      vmax: Math.max(vw, vh),
	      vmin: Math.min(vw, vh)
	    };
	  }
	
	  function importCrossOriginLinks(next) {
	    var _waiting = 0;
	    var decrease = function() {
	      _waiting--;
	      if (!_waiting) {
	        next();
	      }
	    };
	
	    forEach.call(document.styleSheets, function(sheet) {
	      if (!sheet.href || origin(sheet.href) === origin(location.href) || sheet.ownerNode.getAttribute('data-viewport-units-buggyfill') === 'ignore') {
	        // skip <style> and <link> from same origin or explicitly declared to ignore
	        return;
	      }
	
	      _waiting++;
	      convertLinkToStyle(sheet.ownerNode, decrease);
	    });
	
	    if (!_waiting) {
	      next();
	    }
	  }
	
	  function origin(url) {
	    return url.slice(0, url.indexOf('/', url.indexOf('://') + 3));
	  }
	
	  function convertLinkToStyle(link, next) {
	    getCors(link.href, function() {
	      var style = document.createElement('style');
	      style.media = link.media;
	      style.setAttribute('data-href', link.href);
	      style.textContent = this.responseText;
	      link.parentNode.replaceChild(style, link);
	      next();
	    }, next);
	  }
	
	  function getCors(url, success, error) {
	    var xhr = new XMLHttpRequest();
	    if ('withCredentials' in xhr) {
	      // XHR for Chrome/Firefox/Opera/Safari.
	      xhr.open('GET', url, true);
	    } else if (typeof XDomainRequest !== 'undefined') {
	      // XDomainRequest for IE.
	      xhr = new XDomainRequest();
	      xhr.open('GET', url);
	    } else {
	      throw new Error('cross-domain XHR not supported');
	    }
	
	    xhr.onload = success;
	    xhr.onerror = error;
	    xhr.send();
	    return xhr;
	  }
	
	  return {
	    version: '0.6.0',
	    findProperties: findProperties,
	    getCss: getReplacedViewportUnits,
	    init: initialize,
	    refresh: refresh
	  };
	
	}));


/***/ },

/***/ 53:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResponsiveImageLoader = (function () {
	  function ResponsiveImageLoader(options) {
	    _classCallCheck(this, ResponsiveImageLoader);
	
	    this.options = options;
	    this.m_windowScrollPosition = null;
	    this.m_windowScrollPositionPlusHeight = null;
	
	    this.PERCENTAGE_FROM_BOTTOM_OF_SCREEN_TRIGGER = 0.1; //0.2 = 20 percent
	
	    this.initialise();
	  }
	
	  _createClass(ResponsiveImageLoader, [{
	    key: "initialise",
	    value: function initialise() {
	      this.initialiseListeners();
	    }
	  }, {
	    key: "updateVars",
	    value: function updateVars() {
	      var bottomPercentOfScreen = $(window).height() * this.PERCENTAGE_FROM_BOTTOM_OF_SCREEN_TRIGGER;
	      this.m_windowScrollPosition = $(window).scrollTop();
	      this.m_windowScrollPositionPlusHeight = this.m_windowScrollPosition + $(window).height() - bottomPercentOfScreen;
	    }
	  }, {
	    key: "initialiseListeners",
	    value: function initialiseListeners() {
	      var _this = this;
	
	      //Note the page loaded event comes from the 'loading-screen' class
	      $(window).scroll(function () {
	        return _this.onWindowScroll();
	      });
	      $(window).on("resize", function () {
	        return _this.onWindowResized();
	      });
	      $("body").on("check-on-screen-triggers", function () {
	        return _this.onBodyCheckTriggersEvent();
	      });
	    }
	  }, {
	    key: "onBodyCheckTriggersEvent",
	    value: function onBodyCheckTriggersEvent() {
	      this.triggerItemsThatAreAboveOrInViewport();
	    }
	  }, {
	    key: "onPageLoaded",
	    value: function onPageLoaded() {
	      this.triggerItemsThatAreAboveOrInViewport();
	    }
	  }, {
	    key: "onWindowResized",
	    value: function onWindowResized() {
	      this.triggerItemsThatAreAboveOrInViewport();
	    }
	  }, {
	    key: "onWindowScroll",
	    value: function onWindowScroll() {
	      this.triggerItemsThatAreAboveOrInViewport();
	    }
	  }, {
	    key: "triggerItemsThatAreAboveOrInViewport",
	    value: function triggerItemsThatAreAboveOrInViewport() {
	
	      this.updateVars();
	      var context = this;
	      //   $("[class^='-trigger-']:not(.-triggered),[class*=' -trigger-']:not(.-triggered)").each(function()
	
	      $(".-trigger-me:not(.-triggered)").each(function () {
	        var $this = $(this);
	        if ($this.hasClass("-bottom-trigger") && !context.isItemsBottomOnOrAboveScreen($this)) {
	          return;
	        } else if (!context.isItemsTopOnOrAboveScreen($this)) {
	          return;
	        }
	
	        $this.addClass("-triggered");
	      });
	
	      $("video.-trigger-me-play-video:not(.-video-triggered)").each(function () {
	        var $this = $(this);
	        if ($this.hasClass("-bottom-trigger") && !context.isItemsBottomOnOrAboveScreen($this)) {
	          return;
	        } else if (!context.isItemsTopOnOrAboveScreen($this)) {
	          return;
	        }
	
	        $this.trigger("play");
	
	        $this.addClass("-video-triggered");
	      });
	    }
	  }, {
	    key: "isItemsTopOnOrAboveScreen",
	    value: function isItemsTopOnOrAboveScreen(_$element) {
	      var itemScreenPosition = _$element.offset().top;
	      var bIsItemOnScreen = this.m_windowScrollPositionPlusHeight >= itemScreenPosition;
	      return bIsItemOnScreen;
	    }
	  }, {
	    key: "isItemsBottomOnOrAboveScreen",
	    value: function isItemsBottomOnOrAboveScreen(_$element) {
	      var itemScreenPosition = _$element.offset().top + _$element.height();
	      var bIsItemOnScreen = this.m_windowScrollPositionPlusHeight >= itemScreenPosition;
	      return bIsItemOnScreen;
	    }
	  }]);
	
	  return ResponsiveImageLoader;
	})();
	
	exports["default"] = ResponsiveImageLoader;
	module.exports = exports["default"];

/***/ },

/***/ 54:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
		'use strict';
	
		/**
		 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
		 *
		 * @codingstandard ftlabs-jsv2
		 * @copyright The Financial Times Limited [All Rights Reserved]
		 * @license MIT License (see LICENSE.txt)
		 */
	
		/*jslint browser:true, node:true*/
		/*global define, Event, Node*/
	
	
		/**
		 * Instantiate fast-clicking listeners on the specified layer.
		 *
		 * @constructor
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		function FastClick(layer, options) {
			var oldOnClick;
	
			options = options || {};
	
			/**
			 * Whether a click is currently being tracked.
			 *
			 * @type boolean
			 */
			this.trackingClick = false;
	
	
			/**
			 * Timestamp for when click tracking started.
			 *
			 * @type number
			 */
			this.trackingClickStart = 0;
	
	
			/**
			 * The element being tracked for a click.
			 *
			 * @type EventTarget
			 */
			this.targetElement = null;
	
	
			/**
			 * X-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartX = 0;
	
	
			/**
			 * Y-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartY = 0;
	
	
			/**
			 * ID of the last touch, retrieved from Touch.identifier.
			 *
			 * @type number
			 */
			this.lastTouchIdentifier = 0;
	
	
			/**
			 * Touchmove boundary, beyond which a click will be cancelled.
			 *
			 * @type number
			 */
			this.touchBoundary = options.touchBoundary || 10;
	
	
			/**
			 * The FastClick layer.
			 *
			 * @type Element
			 */
			this.layer = layer;
	
			/**
			 * The minimum time between tap(touchstart and touchend) events
			 *
			 * @type number
			 */
			this.tapDelay = options.tapDelay || 200;
	
			/**
			 * The maximum time for a tap
			 *
			 * @type number
			 */
			this.tapTimeout = options.tapTimeout || 700;
	
			if (FastClick.notNeeded(layer)) {
				return;
			}
	
			// Some old versions of Android don't have Function.prototype.bind
			function bind(method, context) {
				return function() { return method.apply(context, arguments); };
			}
	
	
			var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
			var context = this;
			for (var i = 0, l = methods.length; i < l; i++) {
				context[methods[i]] = bind(context[methods[i]], context);
			}
	
			// Set up event handlers as required
			if (deviceIsAndroid) {
				layer.addEventListener('mouseover', this.onMouse, true);
				layer.addEventListener('mousedown', this.onMouse, true);
				layer.addEventListener('mouseup', this.onMouse, true);
			}
	
			layer.addEventListener('click', this.onClick, true);
			layer.addEventListener('touchstart', this.onTouchStart, false);
			layer.addEventListener('touchmove', this.onTouchMove, false);
			layer.addEventListener('touchend', this.onTouchEnd, false);
			layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
			// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
			// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
			// layer when they are cancelled.
			if (!Event.prototype.stopImmediatePropagation) {
				layer.removeEventListener = function(type, callback, capture) {
					var rmv = Node.prototype.removeEventListener;
					if (type === 'click') {
						rmv.call(layer, type, callback.hijacked || callback, capture);
					} else {
						rmv.call(layer, type, callback, capture);
					}
				};
	
				layer.addEventListener = function(type, callback, capture) {
					var adv = Node.prototype.addEventListener;
					if (type === 'click') {
						adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
							if (!event.propagationStopped) {
								callback(event);
							}
						}), capture);
					} else {
						adv.call(layer, type, callback, capture);
					}
				};
			}
	
			// If a handler is already declared in the element's onclick attribute, it will be fired before
			// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
			// adding it as listener.
			if (typeof layer.onclick === 'function') {
	
				// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
				// - the old one won't work if passed to addEventListener directly.
				oldOnClick = layer.onclick;
				layer.addEventListener('click', function(event) {
					oldOnClick(event);
				}, false);
				layer.onclick = null;
			}
		}
	
		/**
		* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
		*
		* @type boolean
		*/
		var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
	
		/**
		 * Android requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS 4 requires an exception for select elements.
		 *
		 * @type boolean
		 */
		var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);
	
	
		/**
		 * iOS 6.0-7.* requires the target element to be manually derived
		 *
		 * @type boolean
		 */
		var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);
	
		/**
		 * BlackBerry requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;
	
		/**
		 * Determine whether a given element requires a native click.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element needs a native click
		 */
		FastClick.prototype.needsClick = function(target) {
			switch (target.nodeName.toLowerCase()) {
	
			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}
	
				break;
			case 'input':
	
				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if ((deviceIsIOS && target.type === 'file') || target.disabled) {
					return true;
				}
	
				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
			}
	
			return (/\bneedsclick\b/).test(target.className);
		};
	
	
		/**
		 * Determine whether a given element requires a call to focus to simulate click into element.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
		 */
		FastClick.prototype.needsFocus = function(target) {
			switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
				case 'button':
				case 'checkbox':
				case 'file':
				case 'image':
				case 'radio':
				case 'submit':
					return false;
				}
	
				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/).test(target.className);
			}
		};
	
	
		/**
		 * Send a click event to the specified element.
		 *
		 * @param {EventTarget|Element} targetElement
		 * @param {Event} event
		 */
		FastClick.prototype.sendClick = function(targetElement, event) {
			var clickEvent, touch;
	
			// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
			if (document.activeElement && document.activeElement !== targetElement) {
				document.activeElement.blur();
			}
	
			touch = event.changedTouches[0];
	
			// Synthesise a click event, with an extra attribute so it can be tracked
			clickEvent = document.createEvent('MouseEvents');
			clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
			clickEvent.forwardedTouchEvent = true;
			targetElement.dispatchEvent(clickEvent);
		};
	
		FastClick.prototype.determineEventType = function(targetElement) {
	
			//Issue #159: Android Chrome Select Box does not open with a synthetic click event
			if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
				return 'mousedown';
			}
	
			return 'click';
		};
	
	
		/**
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.focus = function(targetElement) {
			var length;
	
			// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
			if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
				length = targetElement.value.length;
				targetElement.setSelectionRange(length, length);
			} else {
				targetElement.focus();
			}
		};
	
	
		/**
		 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
		 *
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.updateScrollParent = function(targetElement) {
			var scrollParent, parentElement;
	
			scrollParent = targetElement.fastClickScrollParent;
	
			// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
			// target element was moved to another parent.
			if (!scrollParent || !scrollParent.contains(targetElement)) {
				parentElement = targetElement;
				do {
					if (parentElement.scrollHeight > parentElement.offsetHeight) {
						scrollParent = parentElement;
						targetElement.fastClickScrollParent = parentElement;
						break;
					}
	
					parentElement = parentElement.parentElement;
				} while (parentElement);
			}
	
			// Always update the scroll top tracker if possible.
			if (scrollParent) {
				scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
			}
		};
	
	
		/**
		 * @param {EventTarget} targetElement
		 * @returns {Element|EventTarget}
		 */
		FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
	
			// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
			if (eventTarget.nodeType === Node.TEXT_NODE) {
				return eventTarget.parentNode;
			}
	
			return eventTarget;
		};
	
	
		/**
		 * On touch start, record the position and scroll offset.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchStart = function(event) {
			var targetElement, touch, selection;
	
			// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
			if (event.targetTouches.length > 1) {
				return true;
			}
	
			targetElement = this.getTargetElementFromEventTarget(event.target);
			touch = event.targetTouches[0];
	
			if (deviceIsIOS) {
	
				// Only trusted events will deselect text on iOS (issue #49)
				selection = window.getSelection();
				if (selection.rangeCount && !selection.isCollapsed) {
					return true;
				}
	
				if (!deviceIsIOS4) {
	
					// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
					// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
					// with the same identifier as the touch event that previously triggered the click that triggered the alert.
					// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
					// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
					// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
					// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
					// random integers, it's safe to to continue if the identifier is 0 here.
					if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
						event.preventDefault();
						return false;
					}
	
					this.lastTouchIdentifier = touch.identifier;
	
					// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
					// 1) the user does a fling scroll on the scrollable layer
					// 2) the user stops the fling scroll with another tap
					// then the event.target of the last 'touchend' event will be the element that was under the user's finger
					// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
					// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
					this.updateScrollParent(targetElement);
				}
			}
	
			this.trackingClick = true;
			this.trackingClickStart = event.timeStamp;
			this.targetElement = targetElement;
	
			this.touchStartX = touch.pageX;
			this.touchStartY = touch.pageY;
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				event.preventDefault();
			}
	
			return true;
		};
	
	
		/**
		 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.touchHasMoved = function(event) {
			var touch = event.changedTouches[0], boundary = this.touchBoundary;
	
			if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Update the last position.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchMove = function(event) {
			if (!this.trackingClick) {
				return true;
			}
	
			// If the touch has moved, cancel the click tracking
			if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
				this.trackingClick = false;
				this.targetElement = null;
			}
	
			return true;
		};
	
	
		/**
		 * Attempt to find the labelled control for the given label element.
		 *
		 * @param {EventTarget|HTMLLabelElement} labelElement
		 * @returns {Element|null}
		 */
		FastClick.prototype.findControl = function(labelElement) {
	
			// Fast path for newer browsers supporting the HTML5 control attribute
			if (labelElement.control !== undefined) {
				return labelElement.control;
			}
	
			// All browsers under test that support touch events also support the HTML5 htmlFor attribute
			if (labelElement.htmlFor) {
				return document.getElementById(labelElement.htmlFor);
			}
	
			// If no for attribute exists, attempt to retrieve the first labellable descendant element
			// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
			return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
		};
	
	
		/**
		 * On touch end, determine whether to send a click event at once.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchEnd = function(event) {
			var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
	
			if (!this.trackingClick) {
				return true;
			}
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				this.cancelNextClick = true;
				return true;
			}
	
			if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
				return true;
			}
	
			// Reset to prevent wrong click cancel on input (issue #156).
			this.cancelNextClick = false;
	
			this.lastClickTime = event.timeStamp;
	
			trackingClickStart = this.trackingClickStart;
			this.trackingClick = false;
			this.trackingClickStart = 0;
	
			// On some iOS devices, the targetElement supplied with the event is invalid if the layer
			// is performing a transition or scroll, and has to be re-detected manually. Note that
			// for this to function correctly, it must be called *after* the event target is checked!
			// See issue #57; also filed as rdar://13048589 .
			if (deviceIsIOSWithBadTarget) {
				touch = event.changedTouches[0];
	
				// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
				targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
				targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
			}
	
			targetTagName = targetElement.tagName.toLowerCase();
			if (targetTagName === 'label') {
				forElement = this.findControl(targetElement);
				if (forElement) {
					this.focus(targetElement);
					if (deviceIsAndroid) {
						return false;
					}
	
					targetElement = forElement;
				}
			} else if (this.needsFocus(targetElement)) {
	
				// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
				// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
				if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
					this.targetElement = null;
					return false;
				}
	
				this.focus(targetElement);
				this.sendClick(targetElement, event);
	
				// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
				// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
				if (!deviceIsIOS || targetTagName !== 'select') {
					this.targetElement = null;
					event.preventDefault();
				}
	
				return false;
			}
	
			if (deviceIsIOS && !deviceIsIOS4) {
	
				// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
				// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
				scrollParent = targetElement.fastClickScrollParent;
				if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
					return true;
				}
			}
	
			// Prevent the actual click from going though - unless the target node is marked as requiring
			// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
			if (!this.needsClick(targetElement)) {
				event.preventDefault();
				this.sendClick(targetElement, event);
			}
	
			return false;
		};
	
	
		/**
		 * On touch cancel, stop tracking the click.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.onTouchCancel = function() {
			this.trackingClick = false;
			this.targetElement = null;
		};
	
	
		/**
		 * Determine mouse events which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onMouse = function(event) {
	
			// If a target element was never set (because a touch event was never fired) allow the event
			if (!this.targetElement) {
				return true;
			}
	
			if (event.forwardedTouchEvent) {
				return true;
			}
	
			// Programmatically generated events targeting a specific element should be permitted
			if (!event.cancelable) {
				return true;
			}
	
			// Derive and check the target element to see whether the mouse event needs to be permitted;
			// unless explicitly enabled, prevent non-touch click events from triggering actions,
			// to prevent ghost/doubleclicks.
			if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
				// Prevent any user-added listeners declared on FastClick element from being fired.
				if (event.stopImmediatePropagation) {
					event.stopImmediatePropagation();
				} else {
	
					// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
					event.propagationStopped = true;
				}
	
				// Cancel the event
				event.stopPropagation();
				event.preventDefault();
	
				return false;
			}
	
			// If the mouse event is permitted, return true for the action to go through.
			return true;
		};
	
	
		/**
		 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
		 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
		 * an actual click which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onClick = function(event) {
			var permitted;
	
			// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
			if (this.trackingClick) {
				this.targetElement = null;
				this.trackingClick = false;
				return true;
			}
	
			// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
			if (event.target.type === 'submit' && event.detail === 0) {
				return true;
			}
	
			permitted = this.onMouse(event);
	
			// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
			if (!permitted) {
				this.targetElement = null;
			}
	
			// If clicks are permitted, return true for the action to go through.
			return permitted;
		};
	
	
		/**
		 * Remove all FastClick's event listeners.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.destroy = function() {
			var layer = this.layer;
	
			if (deviceIsAndroid) {
				layer.removeEventListener('mouseover', this.onMouse, true);
				layer.removeEventListener('mousedown', this.onMouse, true);
				layer.removeEventListener('mouseup', this.onMouse, true);
			}
	
			layer.removeEventListener('click', this.onClick, true);
			layer.removeEventListener('touchstart', this.onTouchStart, false);
			layer.removeEventListener('touchmove', this.onTouchMove, false);
			layer.removeEventListener('touchend', this.onTouchEnd, false);
			layer.removeEventListener('touchcancel', this.onTouchCancel, false);
		};
	
	
		/**
		 * Check whether FastClick is needed.
		 *
		 * @param {Element} layer The layer to listen on
		 */
		FastClick.notNeeded = function(layer) {
			var metaViewport;
			var chromeVersion;
			var blackberryVersion;
			var firefoxVersion;
	
			// Devices that don't support touch don't need FastClick
			if (typeof window.ontouchstart === 'undefined') {
				return true;
			}
	
			// Chrome version - zero for other browsers
			chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (chromeVersion) {
	
				if (deviceIsAndroid) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// Chrome 32 and above with width=device-width or less don't need FastClick
						if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
	
				// Chrome desktop doesn't need FastClick (issue #15)
				} else {
					return true;
				}
			}
	
			if (deviceIsBlackBerry10) {
				blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
	
				// BlackBerry 10.3+ does not require Fastclick library.
				// https://github.com/ftlabs/fastclick/issues/251
				if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// user-scalable=no eliminates click delay.
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// width=device-width (or less than device-width) eliminates click delay.
						if (document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
				}
			}
	
			// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
			if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			// Firefox version - zero for other browsers
			firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (firefoxVersion >= 27) {
				// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896
	
				metaViewport = document.querySelector('meta[name=viewport]');
				if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
					return true;
				}
			}
	
			// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
			// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
			if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Factory method for creating a FastClick object
		 *
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		FastClick.attach = function(layer, options) {
			return new FastClick(layer, options);
		};
	
	
		if (true) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return FastClick;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = FastClick.attach;
			module.exports.FastClick = FastClick;
		} else {
			window.FastClick = FastClick;
		}
	}());


/***/ }

});


/** WEBPACK FOOTER **
 ** main.js
 **/